import { CalendarDays, LayoutDashboard, Receipt, Users } from 'lucide-react';
import { ProductLogo } from '@/shared/ui/brand';
import { BrandStatusPage } from './BrandStatusPage';

const NAV_CHIPS = [
  { label: 'Patients', to: '/patients', icon: Users },
  { label: 'Appointments', to: '/appointments/list', icon: CalendarDays },
  { label: 'Billing', to: '/billing/invoices', icon: Receipt },
] as const;

/**
 * Themed 404 page — design from `templates/404.html`.
 * Renders embedded in the app shell so sidebar/header stay usable.
 */
export function NotFoundPage(): JSX.Element {
  return (
    <BrandStatusPage
      layout="embedded"
      tone="brand"
      heroSize="lg"
      heroMotion="float"
      showLogo={false}
      hero={
        <div className="relative flex h-full w-full flex-col items-center justify-center">
          <span className="font-display text-[58px] leading-none font-semibold tracking-tight text-brand-600 select-none">
            404
          </span>
          <ProductLogo
            className="pointer-events-none absolute inset-0 h-full w-full opacity-[0.12] p-6"
            alt=""
          />
          <div className="absolute bottom-9 flex items-center gap-2.5">
            <div className="h-2 w-2 rounded-full bg-brand-600" />
            <div className="h-2 w-2 rounded-full bg-brand-600" />
          </div>
        </div>
      }
      title="Oops! This page went missing."
      description="The page you're looking for doesn't exist or may have been moved. Let's get you back to where your patients are waiting."
      primaryAction={{
        label: 'Back to Dashboard',
        to: '/',
        icon: LayoutDashboard,
        variant: 'primary',
      }}
      navChips={[...NAV_CHIPS]}
      footer="Error 404 · DentXE"
    />
  );
}
